export const environment = {
  targetEnvironment: 'Dev',
  api: 'https://global-entity-service-webapi.review.cloud.orionadvisor.com/v1/',
};
